exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-5bad88ec]{max-width:300px;width:38%;height:auto;border:1px solid #ccc;padding:5px;float:right;margin-left:20px}p[data-v-5bad88ec]{padding-left:15px;text-align:justify}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5bad88ec","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Leadership.vue
// module id = 187
// module chunks = 0